import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageSchools,
  PageSchool,
  PageSchoolEdit,
  PageSchoolStudent,
  PageSchoolAdmin,
} from '../pages/schools';

const RouteSchools = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageSchools />
      </Route>
      <Route exact path={`${path}/:_id`}>
        <PageSchool />
      </Route>
      <Route exact path={`${path}/:_id/edit`}>
        <PageSchoolEdit />
      </Route>
      <Route exact path={`${path}/:_id/students/:studentId`}>
        <PageSchoolStudent />
      </Route>
      <Route exact path={`${path}/:_id/admins/:adminId`}>
        <PageSchoolAdmin />
      </Route>
    </Switch>
  );
};

export default RouteSchools;
